// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"8b928522","133":"c241fed2","182":"ff35a12f"}[chunkId] + ".chunk.js";
};